module.exports = __webpack_public_path__ + "img/third-0-opened.73bc00e0.webp";